import styled from 'styled-components';

import { DistanceInput as DistanceInputOriginal } from './DistanceInput';

export const DistanceInput = styled(DistanceInputOriginal)`
  /* allow the dropdown to have space for content and scrollbar */
  min-width: 100px;
`;
